<template>
  <div class="concentratorStrategys-content">
    <el-transfer
      filterable
      :data="allDevices"
      :titles="['未分配的设备', '已分配的设备']"
      :button-texts="['从列表删除', '添加到列表']"
      v-model="allocated"
      @change="dataChange"
    >
    </el-transfer>
    <br />
    <el-button class="cancel-btn" size="medium" @click="cancel">关闭</el-button>
  </div>
</template>
<script>
import concentratorApi from "@/api/light/concentrator"
import strategyApi from "@/api/light/strategy"
export default {
  name: "sendStrategy",
  props: {
    sendData: {
      type: Object
    },
  },
  data() {
    return {
      allDevices: [],
      allocated: []
    }
  },
  methods: {
    dataChange(value, direction, movedKeys) {
      if (direction === "right") { // 分配
        strategyApi.foucusAllotFen({
          type: 1, // type 类型 0取消1是分配
          ids: movedKeys.toString(),
          stg_id: this.sendData.stg_id
        }).then((res) => {
          if (res.data.code === 1000) {
            this.$message.success("分配成功")
          } else {
            this.$message.error(res.data.message)
          }
        })
      } else { // 取消分配
        strategyApi.foucusAllotFen({
          type: 0, // type 类型 0取消1是分配
          ids: movedKeys.toString(),
          stg_id: this.sendData.stg_id
        }).then((res) => {
          if (res.data.code === 1000) {
            this.$message.success("取消分配成功")
          } else {
            this.$message.error(res.data.message)
          }
        })
      }
    },
    getAllDevices() { // 获取所有路灯，策略是单灯（单灯的所有路灯），策略是双灯（双灯的所有路灯）
      concentratorApi.concentratorList({
        page: 1,
        pageSize: 1000
      }).then((res) => {
        if (res.data.code === 1000) {
          for (const device of res.data.data.list) {
            this.allDevices.push({
              key: device.id,
              label: device.name
            })
          }
          this.getAllocated()
        }
      })
    },
    getAllocated() { // 获取该策略下的所有路灯
      strategyApi.foucusHaveStrategy(this.sendData.stg_id, {
        page: 1,
        pageSize: 1000
      }).then((res) => {
        if (res.data.code === 1000) {
          for (const alodevice of res.data.data) {
            this.allocated.push(alodevice.id)
          }
        }
      })
    },
    cancel() {
      this.$emit('closeMethod')
    }
  },
  created() {
    this.getAllDevices()
  }
}
</script>

<style lang="less">
.concentratorStrategys{
  display: flex;
  align-items: center;
}
</style>
